import { Dropdown } from 'react-bootstrap';
import {  secondsInHour, secondsInDay } from 'date-fns';
import {  Icon } from './Icon';
import clsx from 'clsx';

interface TimeStep {
    label: string;
    duration: Duration;
}

interface TimeHelperProps {
    onSelect:(d: Duration)=>void;
    steps?: TimeStep[]
    className?: string
 }

const defaultTimeSteps = [
    { label:'+1 hour', duration:{hours:1} },
    { label:'+1 day', duration:{days:1} },
    { label:'+1 week', duration:{weeks:1} },
];
 
export const TimeHelper: React.FC<TimeHelperProps> = (props) => {
    
    const item = (step:TimeStep, index:number) =>{
       return <Dropdown.Item key={index} onClick={()=>props.onSelect(step.duration)}>{step.label}</Dropdown.Item>
    }

    const steps = props.steps ?? defaultTimeSteps;
 
    return <Dropdown className={ clsx('d-inline-block', props.className) }>
       <Dropdown.Toggle variant="success" id="dropdown-basic" size='sm'>
         <Icon name="calendar-alt"/>
       </Dropdown.Toggle>
       <Dropdown.Menu>
        {steps.map(item)}
       </Dropdown.Menu>
     </Dropdown>
 }
 
 interface DurationStep {
    label: string;
    seconds: number;
}

const defaultDurationSteps = [
    { label:'1 hour',seconds: secondsInHour  },
    { label:'1 day', seconds:secondsInDay },
    { label:'1 week',seconds: secondsInDay * 7}
];

 interface DurationHelperProps {
    onSelect:(d: number)=>void;
    steps?: DurationStep[]
 }

 export const DurationHelper: React.FC<DurationHelperProps> = (props) => {
    
    const item = (step: DurationStep, index:number) =>{
       return <Dropdown.Item key={index} onClick={()=>props.onSelect(step.seconds)}>{step.label}</Dropdown.Item>
    }
 
    const steps = props.steps ?? defaultDurationSteps;

    return <Dropdown className='d-inline-block'>
       <Dropdown.Toggle variant="success" className='d-inline-block' size='sm'>
         <Icon name="hourglass"/>
       </Dropdown.Toggle>
       <Dropdown.Menu>
        { steps.map(item) }
       </Dropdown.Menu>
     </Dropdown>
 }
 